import React from "react";
import styled from "styled-components";
import {
  Box,
  List,
  Image,
  Text,
  Heading,
  SimpleListItem,
  Button
} from "../../theme";
import {
  Accordion,
  AccordionPanel as AccordionPanelBase,
  Grommet
} from "grommet";
import { Link } from "react-router-dom";
import Pic from "../../assets/av4.JPG";

const AccordionPanel = styled(AccordionPanelBase)`
  font-family: Coromont;
  padding: 24px;
`;
export const Accordian = ({ animate, multiple, labels, texts, ...rest }) => {
  return (
    <Accordion>
      <AccordionPanel label="Overview">
        <Box p={24} bg="#efefef">
          <Text>
            For nearly 40 years, Dan has represented clients across numerous
            practice areas. His vast experience includes not only legal
            achievements, but also community involvement, volunteer service and
            thought leadership within the industry. Dan writes a regular column
            on Estate Planning for the Tennessee Bar Journal and was awarded the
            Justice Joseph W. Henry award for Outstanding Legal Writing in 2001
            He is a Fellow, Regent and past Tennessee State Chair of the
            American College of Trust and Estate Counsel (ACTEC) and serves on
            the ACTEC Charitable Planning and Exempt Organizations Committee. He
            is a member of the Knoxville, Tennessee and Florida Bar
            Associations, The National Lawyers Association and the Christian
            Legal Society. Dan served on the Tennessee Probate Study Group from
            1986 to 2008, a joint ACTEC and Tennessee Bar committee responsible
            for reviewing and drafting proposed state laws regarding estates,
            trusts, property and inheritance, including related tax laws. He is
            a past president of the Knoxville Estate Planning Council and was an
            adjunct professor at the University of Tennessee College of Law in
            1998. Dan is involved with numerous local and national charities and
            is a director or pro bono advisor for selected charities. He was
            awarded the Knoxville Bar Association annual Pro Bono Award in 1991.
            Dan is also a Fellow of the Knoxville Bar Foundation and was in the
            Leadership Knoxville Class of 2002. Dan has spoken at various local,
            state and national meetings and remains an occasional lecturer to
            both professional and lay groups on estate planning topics. Dan
            married his junior high school sweetheart, and they have two sons
            and four grandchildren. He enjoys endurance running, having finished
            the Western States 100 Mile Trail Race at age 61, and can frequently
            be found on the trails of East Tennessee's parks
          </Text>
        </Box>
      </AccordionPanel>

      <AccordionPanel label="Professional Honors & Activities">
        <Box p={24} bg="#efefef">
          <Text class="smaller">
            Fellow and Regent, American College of Trust and Estate Counsel
            (ACTEC)
          </Text>
          <Text class="smaller">
            Listed among "101 Best Lawyers in Tennessee" in 2004 and "150 Best
            Lawyers in Tennessee," 2005 through 2010, Business Tennessee
            Magazine
          </Text>
          <Text class="smaller">
            Named 2012 "Lawyer of the Year" for Trusts and Estates —
            Knoxville, by Best Lawyers in America®
          </Text>
          <Text class="smaller">
            Listed in Best Lawyers in America® since 1989 for Trusts and
            Estates, and more recently for Nonprofit Law
          </Text>
          <Text class="smaller">
            Listed in Tennessee Super Lawyers for estate planning and for
            nonprofit law
          </Text>
          <Text class="smaller">
            Listed in Mid-South Super Lawyers for Estate Planning
          </Text>
          <Text class="smaller">
            Certified Estate Planning Law Specialist (EPLS) by the NAEPC Estate
            Law Specialist Board, Inc.
          </Text>
          <Text class="smaller">
            Master of the Bench, Hamilton Burnett American Inn of Court
          </Text>
        </Box>
      </AccordionPanel>
      <AccordionPanel label="Education">
        <Box p={24} bg="#efefef">
          <Text class="smaller">B.A., Rollins College, 1969</Text>
          <Text class="smaller">M.B.A, Rollins College, 1970</Text>
          <Text class="smaller">J.D., Willamette University, 1977</Text>
          <Text class="smaller">
            L.L.M. in Estate Planning, University of Miami, 1978
          </Text>
        </Box>
      </AccordionPanel>
      <AccordionPanel label="Admissions">
        <Box p={24} bg="#efefef">
          <Text class="smaller">Tennessee, 1978</Text>
          <Text class="smaller">Florida, 1978</Text>
          <Text class="smaller">U.S. Tax Court, 1978</Text>
          <Text class="smaller">U.S. Supreme Court, 1997</Text>
        </Box>
      </AccordionPanel>
    </Accordion>
  );
};
export const PracticeAccordion = ({
  animate,
  multiple,
  labels,
  texts,
  ...rest
}) => {
  return (
    <Accordion>
      <AccordionPanel label="Practice Description">
        <Box p={24} bg="#efefef">
          <Text>
            The firm offers a substantial amount of expertise in tax planning
            and representation of clients before the Internal Revenue Service.
            The tax planning services facilitate the activities of the firm’s
            transactional practice groups, especially in the areas of mergers
            and acquisitions, entity formation and corporate finance. The
            compliance aspects of the practice group include audit and appeals
            representation, offers-in-compromise and installment payment
            structures. In addition to transactional support, the firm possesses
            significant expertise in the formation and operation of tax-exempt
            entities.
          </Text>
        </Box>
      </AccordionPanel>

      <AccordionPanel label="Professionals in this Practice">
        <Box p={24} bg="#efefef">
          <Button tag={Link} to="/people/johnWood">
            P. Newman Bankston{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Keith H. Burroughs{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Dan W. Holbook{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Joe M. McAfee{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            William H. Kittrell{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Joe M. McAfee{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Stephen A. McSween{" "}
          </Button>
          <Button tag={Link} to="/people/johnWood">
            Jonathan D. Reed{" "}
          </Button>
        </Box>
      </AccordionPanel>
      <AccordionPanel label="Related Blog Entries">
        <Box p={24} bg="#efefef">
          <Text class="smaller">B.A., Rollins College, 1969</Text>
          <Text class="smaller">M.B.A, Rollins College, 1970</Text>
          <Text class="smaller">J.D., Willamette University, 1977</Text>
          <Text class="smaller">
            L.L.M. in Estate Planning, University of Miami, 1978
          </Text>
        </Box>
      </AccordionPanel>
      <AccordionPanel label="Included In This Practice">
        <Box p={24} bg="#efefef">
          <Button tag={Link} to="/practices">
            Mergers & Acquisitions{" "}
          </Button>
          <Button tag={Link} to="/practices">
            Like-kind Exchanges{" "}
          </Button>
          <Button tag={Link} to="/practices">
            Federal and State Taxation{" "}
          </Button>
          <Button tag={Link} to="/practices">
            Nonprofit/Tax-Exempt Organizations{" "}
          </Button>
        </Box>
      </AccordionPanel>
    </Accordion>
  );
};
